import { gql } from '@apollo/client'

export default gql`
  query  get2FAConfig{
    get2FAConfig{
        id
        isEnabled
        name
        value
    }
  }
`
